import Panel from 'components/panel/panel'
import styles from './content.module.scss'
import { cn } from 'utils/helpers'

export default function TabContent({ children, active, panel, hidden }) {
    if (hidden) {
        return <div className={cn(styles.hidden, styles[`active${active}`])}>{children}</div>
    }
    if (children[active]) {
        return panel ? <Panel>{children[active]}</Panel> : children[active]
    }
    return ''
}
